import { render, staticRenderFns } from "./sidebarMenu.vue?vue&type=template&id=ee019f2c&"
import script from "./sidebarMenu.vue?vue&type=script&lang=ts&"
export * from "./sidebarMenu.vue?vue&type=script&lang=ts&"
import style0 from "./sidebarMenu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports